export enum RoofTypeEnum {
  CERAMIC = 'CERAMIC',
  GROUND = 'GROUND',
  SLAB = 'SLAB',
  'SLAB-GROUND' = 'SLAB-GROUND',
  TRAPEZOIDAL = 'TRAPEZOIDAL',
  WAVY = 'WAVY',
  ZIPPED = 'ZIPPED',
  W_TYPE_TILE = 'W_TYPE_TILE',
  CCM_SOIL = 'CCM_SOIL',
}

export enum BracketTypeEnum {
  STRUCTURE = 'STRUCTURE',
  RAILS = 'RAILS',
}
